import * as React from "react";
const SvgFiRrBowlChopsticksNoodles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-chopsticks-noodles_svg__a)">
      <path
        fill="#062147"
        d="M23.199 11.599A3.96 3.96 0 0 0 20.002 10h-7.997V7.007H23a1 1 0 1 0 0-2H12.005V3.586l10.983-.58a1 1 0 0 0-.105-1.998l-18.937 1a1 1 0 0 0 .052 1.999h.054l.954-.05v1.051H4a1 1 0 1 0 0 2h1.007v2.993h-.999c-1.27 0-2.435.582-3.196 1.598a4 4 0 0 0-.643 3.55c.708 2.421 1.989 4.605 3.708 6.317 1.617 1.609 3.901 2.533 6.268 2.533h3.722c2.366 0 4.65-.924 6.268-2.534 1.72-1.711 3-3.896 3.707-6.316a4 4 0 0 0-.642-3.551zM7.005 3.85l3-.158v1.315h-3zm0 3.157h3V10h-3zm14.915 7.582c-.604 2.068-1.74 4.007-3.198 5.46C17.476 21.289 15.706 22 13.865 22h-3.722c-1.841 0-3.611-.711-4.856-1.95-1.458-1.453-2.595-3.393-3.199-5.461a2.02 2.02 0 0 1 .322-1.791c.38-.507.962-.798 1.596-.798h15.995c.634 0 1.216.291 1.597.798.386.516.504 1.168.322 1.791"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-chopsticks-noodles_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlChopsticksNoodles;
